var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/icons.svg#help';
                    var viewUrl = 'svg/icons.svg#view-help';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };